// import React, { useRef, useState } from 'react';
// import { Send } from 'lucide-react';
// import { Avatar, AvatarFallback, AvatarImage } from 'app/components/ui/avatar';
// import { Input } from 'app/components/ui/input';

// import {
//   ALERT,
//   CHAT_JOINED,
//   CHAT_LEAVED,
//   NEW_MESSAGE,
//   START_TYPING,
//   STOP_TYPING,
// } from "../constants/events";

// import { useErrors, useSocketEvents } from "../hooks/hook";
// import { useGetSocket } from '../socket';
// import { useDispatch } from 'react-redux';
// import { useNavigate } from 'react-router-dom';
// import { useChatDetailsQuery, useGetMessagesQuery } from '../api/api';

// const ChatContent = ({ selectedUser }) => {
//   const socket = useGetSocket();
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const [message, setMessage] = useState("");
//   const [messages, setMessages] = useState([]);
//   const [IamTyping, setIamTyping] = useState(false);
//   const [userTyping, setUserTyping] = useState(false);
//   const typingTimeout = useRef(null);
//   if (!selectedUser) {
//     return (
//       <div className="w-3/4 h-full flex items-center justify-center bg-gray-50">
//         <p className="text-gray-500">Select a user to start a chat</p>
//       </div>
//     );
//   }

//   return (
//     <div className="w-3/4 h-full flex flex-col bg-gray-50">
//       {/* Header */}
//       <div className="flex items-center px-4 py-2 border-b border-gray-200 bg-white  dark:bg-transparent">
//         <Avatar className="w-10 h-10 mr-3">
//           <AvatarImage
//             src={selectedUser.avatar || '/default-avatar.png'}
//             alt={selectedUser.name}
//             className="object-cover"
//           />
//           <AvatarFallback>{selectedUser.name?.[0] || '?'}</AvatarFallback>
//         </Avatar>
//         <div>
//           <p className="text-base font-semibold">{selectedUser.name}</p>
//           <p className="text-sm text-gray-500">Online</p>
//         </div>
//       </div>

//       {/* Chat Messages */}
//       <div className="flex-1 p-4 overflow-y-auto">
//         <p className="text-sm text-gray-500">
//           Conversation with {selectedUser.name} will appear here.
//         </p>
//       </div>

//       {/* Message Input */}
//       <div className="flex items-center px-4 py-3 border-t border-gray-200 bg-white  dark:bg-transparent">
//         <Input
//           type="text"
//           placeholder="Type a message"
//           className="flex-1 mr-3"
//         />
//         <button className="p-2 rounded-full bg-blue-500 text-white hover:bg-blue-600">
//           <Send className="w-5 h-5" />
//         </button>
//       </div>
//     </div>
//   );
// };

// export default ChatContent;

import React, { useEffect, useRef, useState } from 'react';
import { Send } from 'lucide-react';
import { Avatar, AvatarFallback, AvatarImage } from 'app/components/ui/avatar';
import { Input } from 'app/components/ui/input';

import {
  ALERT,
  CHAT_JOINED,
  CHAT_LEAVED,
  NEW_MESSAGE,
  START_TYPING,
  STOP_TYPING,
} from '../constants/events';

import { useGetSocket } from '../socket';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const ChatContent = ({ selectedUser }) => {
  const socket = useGetSocket();

  const typingTimeout = useRef(null);

  if (!selectedUser) {
    return (
      <div className="w-3/4 h-full flex items-center justify-center bg-gray-50">
        <p className="text-gray-500">Select a user to start a chat</p>
      </div>
    );
  }

  return (
    <div className="w-3/4 h-full flex flex-col bg-gray-50">
      {/* Header */}
      <div className="flex items-center px-4 py-2 border-b border-gray-200 bg-white  dark:bg-transparent">
        <Avatar className="w-10 h-10 mr-3">
          <AvatarImage
            src={selectedUser.avatar || '/default-avatar.png'}
            alt={selectedUser.name}
            className="object-cover"
          />
          <AvatarFallback>{selectedUser.name?.[0] || '?'}</AvatarFallback>
        </Avatar>
        <div>
          <p className="text-base font-semibold">{selectedUser.name}</p>
          <p className="text-sm text-gray-500">Online</p>
        </div>
      </div>

      {/* Chat Messages */}
      <div className="flex-1 p-4 overflow-y-auto">
        <p className="text-sm text-gray-500">
          Conversation with {selectedUser.name} will appear here.
        </p>
      </div>

      {/* Message Input */}

      <form>
        <div className="flex items-center px-4 py-3 border-t border-gray-200 bg-white  dark:bg-transparent">
          <Input
            type="text"
            placeholder="Type a message"
            className="flex-1 mr-3"
          />
          <button className="p-2 rounded-full bg-blue-500 text-white hover:bg-blue-600">
            <Send className="w-5 h-5" />
          </button>
        </div>
      </form>
    </div>
  );
};

export default ChatContent;
